import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useInView, reveal } from '../home/motion';
import { BOOK_URL } from '../../config';
import { useT } from '../../i18n/LanguageContext';

const book = require('../../assets/img/Libro.png');

export default function PlatformHero() {
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useT();
  const { ref, visible } = useInView();

  return (
    <Box sx={{ bgcolor: theme.home.paper, pt: { xs: 8, md: 12 }, pb: { xs: 6, md: 8 }, position: 'relative', overflow: 'hidden' }}>
      <Box sx={{ position: 'absolute', inset: 0, backgroundImage: theme.home.grain, opacity: 0.5, pointerEvents: 'none' }} />
      <Box
        ref={ref}
        sx={{
          maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 }, position: 'relative',
          display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.1fr 0.9fr' }, gap: { xs: 6, md: 8 }, alignItems: 'center',
        }}>
        <Box>
          <Typography variant="overline" sx={{ color: theme.home.coralText, ...reveal(visible) }}>
            {t('platform.hero.eyebrow')}
          </Typography>
          <Typography variant="h1" sx={{
            mt: 1.5, color: theme.home.ink, fontSize: { xs: '2.4rem', md: '3.4rem' }, ...reveal(visible, 0.08),
          }}>
            {t('platform.hero.title')}
          </Typography>
          <Typography sx={{
            mt: 3, color: theme.home.inkMuted, fontSize: { xs: '1.1rem', md: '1.25rem' }, lineHeight: 1.65,
            maxWidth: 560, ...reveal(visible, 0.16),
          }}>
            {t('platform.hero.body')}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 4.5, ...reveal(visible, 0.24) }}>
            <Button
              variant="contained" size="large" endIcon={<ArrowForwardIcon />}
              href={BOOK_URL} target="_blank" rel="noopener noreferrer"
              sx={{ px: 3.5, py: 1.4, borderRadius: 999, bgcolor: theme.home.coralText, '&:hover': { bgcolor: theme.home.coralHover } }}
            >
              {t('platform.hero.ctaBuy')}
            </Button>
            <Button
              variant="outlined" size="large" onClick={() => navigate('/redeem')}
              sx={{ px: 3.5, py: 1.4, borderRadius: 999, borderColor: theme.home.ink, color: theme.home.ink,
                '&:hover': { borderColor: theme.home.ink, bgcolor: 'rgba(20,24,29,0.04)' } }}
            >
              {t('platform.hero.ctaRedeem')}
            </Button>
          </Stack>
        </Box>

        <Box sx={{ position: 'relative', textAlign: 'center', ...reveal(visible, 0.12) }}>
          <Box sx={{
            position: 'absolute', inset: '8% 14%', borderRadius: 4,
            background: `linear-gradient(135deg, ${theme.home.cyan}33, ${theme.home.coral}33)`, transform: 'rotate(-4deg)',
          }} />
          <Box component="img" src={book} alt={t('platform.hero.imgAlt')}
            sx={{ position: 'relative', width: '100%', maxWidth: 320, mx: 'auto', filter: 'drop-shadow(0 30px 50px rgba(20,24,29,0.35))' }} />
        </Box>
      </Box>
    </Box>
  );
}
